   export class PushNotification {
        remarks: string;
        agentNames: any;
        agentid:string;
        loginuser:string;
    }
